export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.3513 14.6667L4.16797 13.4834L9.6513 8.00004L4.16797 2.51671L5.3513 1.33337L12.018 8.00004L5.3513 14.6667Z"
      fill="#3C52EF"
    />
  </svg>
)
